import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/loader';
import useContentPermission from 'hook/use-content-permission';

const AccessSubscriptionGuard = ({ children, isSubscriptionLoaded, isEntitlementsLoaded }) => {
  const { hasSubscriptionFlow } = useContentPermission();
  return !hasSubscriptionFlow || (isSubscriptionLoaded && isEntitlementsLoaded) ? children : <Loader withOverlay />;
};

AccessSubscriptionGuard.propTypes = {
  isSubscriptionLoaded: PropTypes.bool.isRequired,
  isEntitlementsLoaded: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

export default AccessSubscriptionGuard;
